import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { IncotermsComplementType } from "../../../../../types/incotermsComplement";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEditIncotermsComplement: (id: number | string) => void;
  onDeleteIncotermsComplement: (id: number | string) => void;
  onViewIncotermsComplement: (id: number | string) => void;
  data: IncotermsComplementType[];
  [x: string]: any;
}
export default function DataTable({
  onEditIncotermsComplement,
  onDeleteIncotermsComplement,
  onViewIncotermsComplement,
  data,
  userValidation,
  ...props
}: DataTableProps) {
  const renderMenus = (row: any) => {
    return [
      <GridActionsCellItem
        sx={{
          display:
            hasClaim("Incoterms Compl - Maintenance") ||
            hasClaim("Incoterms Compl - Visualization")
              ? "block"
              : "none",
        }}
        key={`view-${row.ID_INCOTERMS_COMPL}`}
        icon={<VisibilityIcon />}
        label="View"
        onClick={() => onViewIncotermsComplement(row.ID_INCOTERMS_COMPL)}
        color="inherit"
        data-testid="view-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Incoterms Compl - Maintenance") ? "block" : "none",
        }}
        key={`edit-${row.ID_INCOTERMS_COMPL}`}
        icon={<EditIcon />}
        label="Edit"
        className="textPrimary"
        onClick={() => onEditIncotermsComplement(row.ID_INCOTERMS_COMPL)}
        color="inherit"
        data-testid="edit-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Incoterms Compl - Maintenance") ? "block" : "none",
        }}
        key={`delete-${row.ID_INCOTERMS_COMPL}`}
        icon={<DeleteIcon />}
        label="Delete"
        onClick={() => onDeleteIncotermsComplement(row.ID_INCOTERMS_COMPL)}
        color="inherit"
        data-testid="delete-button"
      />,
    ];
  };

  const columns: GridColDef[] = [
    {
      field: "DSC_INCOTERMS_COMPL",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "ATIVO",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Date>) =>
        params.value ? (
          <Chip label="Active" color="primary" />
        ) : (
          <Chip label="Inactive" variant="outlined" />
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(row),
    },
  ];
  return (
    <>
      <DataTableDefault
        rowId={data.map((row) => row.ID_INCOTERMS_COMPL)}
        data-testid="incoterms-complement-data-table"
        data={data}
        columns={columns}
        {...props}
      />
    </>
  );
}
